var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "Ads Settings" },
        scopedSlots: _vm._u([
          {
            key: "button",
            fn: function() {
              return [
                _vm.isEdit
                  ? _c("Button", {
                      attrs: { variant: "default", label: "Cancel" },
                      on: { clicked: _vm.disableEdit }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isEdit
                  ? _c("Button", {
                      attrs: { variant: "primary", label: "Edit" },
                      on: { clicked: _vm.setEdit }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isEdit
                  ? _c("Button", {
                      attrs: { variant: "primary", label: "Save" },
                      on: { clicked: _vm.save }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-col" },
                  [
                    _c(
                      "h5",
                      {
                        staticClass:
                          "text-gray-700 text-sm mt-3 mb-6 font-bold uppercase text-left"
                      },
                      [_vm._v("\n          Ads Form\n        ")]
                    ),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Number of Songs" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("Input", {
                                attrs: {
                                  disabled: !_vm.isEdit,
                                  placeholder: "Number of Songs",
                                  error:
                                    (_vm.$v.numberOfSongs.$dirty &&
                                      !_vm.$v.numberOfSongs.required) ||
                                    (_vm.$v.numberOfSongs.$dirty &&
                                      !_vm.$v.numberOfSongs.integer) ||
                                    (_vm.$v.numberOfSongs.$dirty &&
                                      !_vm.$v.numberOfSongs.minValue)
                                },
                                model: {
                                  value: _vm.numberOfSongs,
                                  callback: function($$v) {
                                    _vm.numberOfSongs = $$v
                                  },
                                  expression: "numberOfSongs"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex flex-col pt-2" },
                                [
                                  _vm.$v.numberOfSongs.$dirty &&
                                  !_vm.$v.numberOfSongs.required
                                    ? _c("text-error", {
                                        attrs: {
                                          text: "Please fill Number Of Songs."
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$v.numberOfSongs.$dirty &&
                                  !_vm.$v.numberOfSongs.integer
                                    ? _c("text-error", {
                                        attrs: {
                                          text: "Value must be an integer."
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$v.numberOfSongs.$dirty &&
                                  !_vm.$v.numberOfSongs.minValue
                                    ? _c("text-error", {
                                        attrs: {
                                          text:
                                            "Value must be greater than zero."
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex flex-col border-b border-gray-200 py-3"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex justify-between" },
                      [
                        _c(
                          "h5",
                          {
                            staticClass:
                              "text-gray-700 text-sm py-2 font-bold uppercase"
                          },
                          [_vm._v("\n            Ads List\n          ")]
                        ),
                        _vm._v(" "),
                        _vm.isEdit
                          ? _c("Button", {
                              attrs: {
                                variant: "outline-primary",
                                label: "Add Ad"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "any",
                                    fn: function() {
                                      return [
                                        _c("input", {
                                          staticStyle: {
                                            width: "100%",
                                            height: "100%",
                                            position: "absolute",
                                            left: "0",
                                            top: "0",
                                            opacity: "0",
                                            cursor: "pointer",
                                            "z-index": "2"
                                          },
                                          attrs: {
                                            type: "file",
                                            name: "fileAds"
                                          },
                                          on: { change: _vm.onFileMusicChange }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                785860129
                              )
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isEmptyFiles && _vm.isEdit
                      ? _c("text-error", {
                          attrs: { text: "Files cannot be empty" }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.files,
                      "row-key": "id",
                      "show-header": false
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "Song", width: "50px" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [_c("span", [_vm._v(_vm._s(scope.row.no))])]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "Song", width: "auto" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.filename))])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "Song", width: "250px" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "audio",
                                {
                                  staticClass: "audio-player",
                                  staticStyle: { width: "240px" },
                                  attrs: {
                                    controls: "",
                                    src: scope.row.file,
                                    id: "audioPlayer" + scope.row.id,
                                    controlsList: "nodownload",
                                    type: "audio/mp3",
                                    preload: "none"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              Audio tag not supported\n            "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "Actions", align: "right" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "static inline-block text-left container-action"
                                },
                                [
                                  _vm.isEdit
                                    ? _c(
                                        "VueCustomTooltip",
                                        {
                                          attrs: {
                                            label: "Delete",
                                            position: "is-left"
                                          }
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "p-2 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none",
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeFile(
                                                    scope.row.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "text-white",
                                                attrs: {
                                                  icon: ["fa", "trash-alt"]
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.files.length === 0
                  ? _c("div", { staticClass: "flex justify-center py-6" }, [
                      _vm._v(
                        "\n        No ads added. Please add an ad to continue\n      "
                      )
                    ])
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f4930ed", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f4930ed","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/AppSetting/AdsSettings.vue
// module id = null
// module chunks = 